var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.693 1.60532C11.8736 1.46489 12.1264 1.46489 12.307 1.60532L21.307 8.60532C21.4288 8.70005 21.5 8.8457 21.5 9V20C21.5 20.663 21.2366 21.2989 20.7678 21.7678C20.2989 22.2366 19.663 22.5 19 22.5H5C4.33696 22.5 3.70107 22.2366 3.23223 21.7678C2.76339 21.2989 2.5 20.663 2.5 20V9C2.5 8.8457 2.57124 8.70005 2.69303 8.60532L11.693 1.60532ZM3.5 9.24454V20C3.5 20.3978 3.65804 20.7794 3.93934 21.0607C4.22064 21.342 4.60218 21.5 5 21.5H19C19.3978 21.5 19.7794 21.342 20.0607 21.0607C20.342 20.7794 20.5 20.3978 20.5 20V9.24454L12 2.63343L3.5 9.24454Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12C8.5 11.7239 8.72386 11.5 9 11.5H15C15.2761 11.5 15.5 11.7239 15.5 12V22C15.5 22.2761 15.2761 22.5 15 22.5C14.7239 22.5 14.5 22.2761 14.5 22V12.5H9.5V22C9.5 22.2761 9.27614 22.5 9 22.5C8.72386 22.5 8.5 22.2761 8.5 22V12Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.a15cf729d12467aba34df9228a870db2.svg";